import React, { Component, useEffect, useState } from "react";
import ReactDOMServer from "react-dom/server";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import Content from "../common/template/content";
import ContentCard from "../common/template/contentCard";
import ContentCardHeader from "../common/template/contentCardHeader";
import ContentCardBody from "../common/template/contentCardBody";
import Row from "../common/layout/row";
import Grid from "../common/layout/grid";
import Table from "../common/table/table";
import THead from "../common/table/tHead";
import Tr from "../common/table/tr";
import NewTr from "../common/table/newTr";
import Th from "../common/table/th";
import TBody from "../common/table/tBody";
import Td from "../common/table/td";
import ButtonTable from "../common/table/buttonTable";
import FormDataPagamento from "./faturaFormDataPagamento";
import { DisplayPDF } from "../displayPDF/displayPDF";
import Button from "../common/button/button";
import DateFormat from "../common/dateFormat/DateFormat";
import TabelaFaturaClientePDF from "../htmlToPdf/TabelaFaturaClientePDF";
import { adicionarPontosMilhar } from "../utils/adicionarPontosMilhar";

import {
    setModoTela,
    initForm,
    setFiltro,
    getListaFaturasCliente,
    buscarPdf,
    setDataPagamento,
    setAguardando,
    incluirDownloadRealizado,
    excluirDownloadRealizado,
    baixarMultiplasFaturasPdf,
    imprimirMultiplasFaturas,
    gerarRelatorio,
} from "./faturaAguaActions";

import { setArquivoPDF } from "../displayPDF/displayPDFActions";
import { Loading } from "../common/loading/loading";
import { setError } from "../common/toast/toast";
import { ModalGestorConcessonaria } from "../analise/components/ModalGestorConcessionaria";
import { FiltrosFaturasClienteAgua } from "./components/FiltrosFaturasClienteAgua";

const DAFAULT_STATE = {
    statusCorBranca: true, //não importado
    statusCorAzul: true, //importadas e NÃO vencidas
    statusCorAmarela: true, //falta 2 dias para o vencimento
    statusCorVermelha: true, //vencidas e não pagas
    statusCorVerde: true, //qualquer uma paga
    situacaoDownload: 1, //Mostra todas
    exibirModalSelecaoFatura: false,
    exibirModalFaturasVencidas: false,
    itemPdfSelecionado: null,
    exibirModalGestorConcessionaria: false,
    itemSelecionado: null,
};

const CORES = {
    BRANCA: { backgroundColorTr: "rgb(255, 255, 255)", backgroundColorTd: "rgb(245, 245, 245)" },
    //se estiver paga retorna verde
    VERDE: { backgroundColorTr: "rgb(221, 255, 221)", backgroundColorTd: "rgb(68, 255, 170)" },
    AZUL: {
        backgroundColorTr: "rgb(243 255 255)",
        backgroundColorTd: "rgb(197 255 255)",
    },
    AMARELA: {
        backgroundColorTr: "rgb(255 255 212)",
        backgroundColorTd: "rgb(255 239 113)",
    },
    VERMELHA: {
        backgroundColorTr: "rgb(251 202 202)",
        backgroundColorTd: "rgb(255 101 105)",
    },
};

const INITIAL_TOTAIS = {
    quantidadeUnidadesFiltradas: 0,
    qtdCorBranca: 0,
    qtdCorAmarela: 0,
    qtdCorAzul: 0,
    qtdCorVerde: 0,
    qtdCorVermelha: 0,
    totalValorFatura: 0,
};

function FaturaAguaCliente(props) {
    const [faturasFiltradas, setFaturasFiltradas] = useState([]);
    const [state, setState] = useState(DAFAULT_STATE);
    const [totais, setTotais] = useState(INITIAL_TOTAIS);

    useEffect(() => {
        if (!props.usuarioLogado) return;

        if (props.usuarioLogado.acesso_cliente) {
            props.setFiltro({
                ...props.filtro,
                id_cliente: props.usuarioLogado.id_cliente,
            });
        }
    }, []);

    useEffect(() => {
        if (!props.usuarioLogado || (props.usuarioLogado.acesso_cliente && props.filtro.id_cliente != props.usuarioLogado.id_cliente)) return;
        props.getListaFaturasCliente();
    }, [props.usuarioLogado, props.filtro]);

    useEffect(() => {
        if (!props.usuarioLogado || (props.usuarioLogado.acesso_cliente && props.filtro.id_cliente != props.usuarioLogado.id_cliente)) {
            setFaturasFiltradas([]);
            return;
        }

        const listaAtualizada = [];
        const totaisAtualizados = { ...INITIAL_TOTAIS };
        for (const item of props.lista) {
            if (!itemCorrespondeAoFiltro(item)) {
                // console.log("uc" + item.id_unidade_consumidora + " IGNORADA");
                continue;
            }
            listaAtualizada.push(item);
            contabilizarTotais({ item, totais: totaisAtualizados });
            // console.log(item.id_unidade_consumidora + " INCLUIDO");
        }

        setFaturasFiltradas(listaAtualizada);
        setTotais(totaisAtualizados);

        setFaturasFiltradas(listaAtualizada);
    }, [
        props.lista,
        props.usuarioLogado,
        props.filtro,
        state.situacaoDownload,
        state.statusCorAzul,
        state.statusCorAmarela,
        state.statusCorVermelha,
        state.statusCorVerde,
        state.statusCorBranca,
    ]);

    const usuarioLogadoAcessoCliente = props.usuarioLogado && props.usuarioLogado.acesso_cliente;

    if (props.pdf) {
        return (
            <DisplayPDF
                setDownloadRealizado={() => props.incluirDownloadRealizado([props.id_pdf])}
                closePdf={props.setArquivoPDF}
                pdfBase64={props.pdf}
                nomePdf={props.nomePdf}
                zoomParametro={1.5}
            />
        );
    }
    return (
        <div>
            {props.aguardando ? <Loading /> : null}

            <Content>
                {props.modoTela === "lista" ? lista() : null}
                {props.modoTela === "alterarDataPagamento" ? <FormDataPagamento onSubmit={props.setDataPagamento} /> : null}
                {props.modoTela === "excluirDataPagamento" ? <FormDataPagamento excluir onSubmit={props.setDataPagamento} /> : null}
                {props.modoTela === "visualizarDataPagamento" ? <FormDataPagamento visualizar /> : null}
            </Content>
        </div>
    );

    function itemCorrespondeAoFiltro(item) {
        const azuis = item.cor === "AZUL" && state.statusCorAzul;
        const amarelos = item.cor === "AMARELA" && state.statusCorAmarela;
        const vermelhos = item.cor === "VERMELHA" && state.statusCorVermelha;
        const verdes = item.cor === "VERDE" && state.statusCorVerde;
        const brancos = item.cor === "BRANCA" && state.statusCorBranca;
        const filtroPorCores = brancos || verdes || azuis || amarelos || vermelhos;

        //1 traz todas, 2 apenas baixadas, 3 apenas download pendente
        const filtroSituacaoDownload =
            state.situacaoDownload == 2 ? validarDownloadRealizado(item) : state.situacaoDownload == 3 ? !validarDownloadRealizado(item) : state.situacaoDownload == 1;

        const filtroConcessionaria = !props.filtro.id_concessionaria || props.filtro.id_concessionaria == item.id_concessionaria_agua;

        return filtroPorCores && filtroSituacaoDownload && filtroConcessionaria;
    }

    function contabilizarTotais({ item, totais }) {
        totais.quantidadeUnidadesFiltradas++;
        totais.totalValorFatura += parseFloat(item.valor_fatura > 0 ? item.valor_fatura : 0);

        if (item.cor === "BRANCA") totais.qtdCorBranca++;
        if (item.cor === "AMARELA") totais.qtdCorAmarela++;
        if (item.cor === "AZUL") totais.qtdCorAzul++;
        if (item.cor === "VERDE") totais.qtdCorVerde++;
        if (item.cor === "VERMELHA") totais.qtdCorVermelha++;
    }

    function getStyleSlimCard(bgColor, textColor) {
        return {
            borderRadius: 8,
            cursor: "pointer",
            backgroundColor: bgColor,
            color: textColor || "#000000",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "10px 10px 0px 10px",
            width: "100%",
            minHeight: "52px",
            margin: 5,
            boxShadow: "#9b9b9b 0px 1px 2px 1px",
        };
    }

    function listarUCsFiltradas() {
        const clienteFiltradoNaoTemUcAgua = !props.listaCliente.find((cli) => cli.id == props.filtro.id_cliente);
        return props.listaUnidadeConsumidora.filter(
            (item) =>
                ((!props.filtro.id_cliente || clienteFiltradoNaoTemUcAgua) && props.usuarioLogado && props.usuarioLogado.administrador) ||
                item.id_cliente == props.filtro.id_cliente
        );
    }

    function validarDownloadRealizado(item) {
        return !!(item.id_usuario_download_realizado || []).find((id_usuario) => id_usuario == props.usuarioLogado.id);
    }

    function montarBotoes(item) {
        const botoes = [];
        if (item.cor && item.cor !== "BRANCA") {
            if (item.data_pagamento) {
                botoes.push({
                    title: "Remover data de pagamento",
                    type: "danger",
                    disabled: !props.usuarioLogado.acesso_fatura_data_pagamento_editar,
                    event: () => {
                        const registro = {
                            dados_fatura: {
                                competencia: String(item.competencia).substring(4) + "/" + String(item.competencia).substring(0, 4),
                                nome_cliente: item.nome_cliente,
                                nome_unidade_consumidora: item.nome_unidade_consumidora,
                                data_vencimento: item.data_vencimento ? String(item.data_vencimento).substring(0, 10) : null,
                            },
                            id: item.id,
                            id_cliente: item.id_cliente,
                            id_unidade_consumidora: item.id_unidade_consumidora,
                            data_pagamento: item.data_pagamento && item.data_pagamento_valida ? String(item.data_pagamento).substring(0, 10) : null,
                            comprovantes_pagamento: JSON.parse(item.comprovantes_pagamento),
                            id_usuario_data_pagamento: props.usuarioLogado.id,
                        };
                        //define a data atual
                        props.setModoTela("excluirDataPagamento", registro);
                        props.initForm(registro);
                        //props.setDataPagamento(item);
                    },
                    children: (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                flexWrap: "noWrap",
                            }}
                        >
                            <i className="fas fa-comment-dollar"></i>
                            <i className="fas fa-times" style={{ fontSize: "0.6rem" }}></i>
                        </div>
                    ),
                });
            } else {
                botoes.push({
                    title: "Adicionar data de pagamento",
                    type: "success",
                    icon: "fas fa-comment-dollar",
                    disabled: !props.usuarioLogado.acesso_fatura_data_pagamento_editar,
                    event: () => {
                        const registro = {
                            dados_fatura: {
                                competencia: String(item.competencia).substring(4) + "/" + String(item.competencia).substring(0, 4),
                                nome_cliente: item.nome_cliente,
                                nome_unidade_consumidora: item.nome_unidade_consumidora,
                                data_vencimento: item.data_vencimento ? String(item.data_vencimento).substring(0, 10) : null,
                            },
                            id: item.id,
                            id_cliente: item.id_cliente,
                            id_unidade_consumidora: item.id_unidade_consumidora,
                            data_pagamento: new Date().toISOString().substring(0, 10),
                            comprovantes_pagamento: JSON.parse(item.comprovantes_pagamento),
                            id_usuario_data_pagamento: props.usuarioLogado.id,
                        };
                        //define a data atual
                        props.setModoTela("alterarDataPagamento", registro);
                        props.initForm(registro);
                        //props.setDataPagamento(item);
                    },
                });
            }
            if (item.arquivo_pdf) {
                botoes.push({
                    style: {
                        width: 38,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    },
                    title: "Visualizar",
                    type: "primary",
                    icon: "fas fa-eye",
                    event: () => {
                        const registro = {
                            dados_fatura: {
                                competencia: String(item.competencia).substring(4) + "/" + String(item.competencia).substring(0, 4),
                                nome_cliente: item.nome_cliente,
                                nome_unidade_consumidora: item.nome_unidade_consumidora,
                                data_vencimento: item.data_vencimento ? String(item.data_vencimento).substring(0, 10) : null,
                            },
                            id: item.id,
                            id_cliente: item.id_cliente,
                            id_unidade_consumidora: item.id_unidade_consumidora,
                            data_pagamento: item.data_pagamento ? String(item.data_pagamento).substring(0, 10) : null,
                            comprovantes_pagamento: JSON.parse(item.comprovantes_pagamento),
                            id_usuario_data_pagamento: props.usuarioLogado.id,
                        };
                        //define a data atual
                        props.setModoTela("visualizarDataPagamento", registro);
                        props.initForm(registro);
                    },
                });
            }
        }
        return botoes;
    }

    function buildRow(item) {
        let textColor = "#000";
        let backgroundColorTr = CORES[item.cor].backgroundColorTr;
        let backgroundColorTd = CORES[item.cor].backgroundColorTd;
        //se o download foi realizado diminui 50 de cada valor rgb, pra escurecer a linha
        if (validarDownloadRealizado(item)) {
            textColor = "#FFF";
            backgroundColorTr = `rgb(${backgroundColorTr.match(/\d+/g).map((v) => (parseInt(v) >= 90 ? parseInt(v) - 90 : 0))})`;
            backgroundColorTd = `rgb(${backgroundColorTd.match(/\d+/g).map((v) => (parseInt(v) >= 90 ? parseInt(v) - 90 : 0))})`;
        }
        const botoes = montarBotoes(item);

        const dataPagamento = (
            <>
                {item.nome_usuario_data_pagamento && !item.data_pagamento
                    ? "Removida"
                    : item.data_pagamento && !item.data_pagamento_valida
                      ? "Indisponível"
                      : DateFormat.formatarDataSqlParaTela(item.data_pagamento)}
            </>
        );
        const mensagensImportacao =
            !item.mensagem_ultima_importacao_data_pagamento_agua || String(item.mensagem_ultima_importacao_data_pagamento_agua).includes("OK") || item.data_pagamento
                ? null
                : `DATA DE PAGAMENTO - ${item.mensagem_ultima_importacao_data_pagamento_agua}`;

        const faturaNaoImportada = !item.arquivo_pdf || ((item.erros || []).length && !item.importacao_validada);
        return (
            <NewTr
                style={{ color: textColor }}
                backgroundColorTr={backgroundColorTr}
                backgroundColorTd={backgroundColorTd}
                key={`${item.id_unidade_consumidora_agua}-${item.id}`}
                botoes={botoes}
            >
                <Td backgroundColor={faturaNaoImportada ? null : backgroundColorTd} alignCenter minWidth={100}>
                    <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: 88 }}>
                        {faturaNaoImportada ? <div style={{ paddingBlock: 12 }}>Não Importado</div> : "Validado"}
                        {props.usuarioLogado.administrador && mensagensImportacao ? (
                            <ButtonTable
                                solid={true}
                                style={{
                                    margin: 0,
                                    borderRadius: "48%",
                                    width: 35,
                                    height: 34,
                                    cursor: "help",
                                }}
                                title={mensagensImportacao}
                                type={"primary"}
                                icon={"fas fa-info"}
                                visible={true}
                                event={() => ({})}
                            />
                        ) : null}
                    </div>
                </Td>

                <Td minWidth={50} alignCenter>
                    {item.competencia_formatada}
                </Td>
                {!usuarioLogadoAcessoCliente && (
                    <Td backgroundColor={faturaNaoImportada ? null : backgroundColorTd} minWidth={80}>
                        {item.nome_cliente}
                    </Td>
                )}
                <Td backgroundColor={faturaNaoImportada ? null : backgroundColorTd} minWidth={120}>
                    {item.nome_unidade_consumidora + " (" + item.nome_concessionaria + ")"}
                </Td>
                <Td backgroundColor={faturaNaoImportada ? null : backgroundColorTd} minWidth={50} alignCenter>
                    {DateFormat.formatarDataSqlParaTela(item.data_vencimento)}
                </Td>
                <Td backgroundColor={faturaNaoImportada ? null : backgroundColorTd} minWidth={100} alignCenter>
                    {dataPagamento}
                </Td>

                <Td backgroundColor={faturaNaoImportada ? null : backgroundColorTd} minWidth={120} alignCenter>
                    <>
                        <p style={{ margin: 0 }}>{item.data_pagamento ? item.nome_usuario_data_pagamento || "Definida pelo sistema" : item.nome_usuario_data_pagamento}</p>
                        <p style={{ margin: 0 }}>{item.datahora_alteracao_data_pagamento && DateFormat.formatarDataHoraSqlParaTela(item.datahora_alteracao_data_pagamento)}</p>
                    </>
                </Td>
                <Td backgroundColor={faturaNaoImportada ? null : backgroundColorTd} minWidth={50} alignCenter>
                    {"R$ " + adicionarPontosMilhar(item.valor_fatura || 0)}
                </Td>

                <Td alignCenter minWidth={150} backgroundColor={faturaNaoImportada ? null : backgroundColorTd}>
                    {item.arquivo_pdf && (!(item.erros || []).length || item.importacao_validada || props.usuarioLogado.administrador) ? (
                        <ButtonTable
                            style={{ width: "95%", height: "35px", margin: "5px 2px 4px " }}
                            title="Visualizar PDF"
                            type={"primary"}
                            icon={"fas fa-file-pdf"}
                            visible={true}
                            event={() => {
                                if (item.id_tipo_mercado == 2) {
                                    return setState({
                                        ...state,
                                        exibirModalSelecaoFatura: true,
                                        itemPdfSelecionado: item,
                                    });
                                }
                                props.buscarPdf(
                                    item.id,
                                    `Fatura_UC-${item.nome_unidade_consumidora.split("-")[0].trim()}_${String(item.competencia).substring(4, 6)}-${String(
                                        item.competencia
                                    ).substring(0, 4)}`
                                );
                                props.setArquivoPDF();
                            }}
                        >
                            <div style={{ display: "flex", alignItems: "center", gap: "6px", justifyContent: "center" }}>
                                <i className="fas fa-file-pdf"></i>
                                <span style={{ marginTop: "2px", fontSize: "14px", fontWeight: "bold" }}>Baixar Fatura</span>
                            </div>
                        </ButtonTable>
                    ) : null}

                    {/* DATA DE EMISSÃO */}
                    <div>
                        {item.data_emissao ? (
                            <p
                                style={{
                                    textAlign: "center",
                                    fontSize: "0.6rem",
                                    margin: "0",
                                }}
                            >
                                Emitida em: {DateFormat.formatarDataSqlParaTela(item.data_emissao)}
                            </p>
                        ) : null}
                    </div>
                </Td>
                <Td alignCenter minWidth={50} backgroundColor={faturaNaoImportada ? null : backgroundColorTd}>
                    {item.arquivo_pdf && (!(item.erros_importacao || []).length || item.importacao_validada || props.usuarioLogado.administrador) ? (
                        <ButtonTable
                            style={{ margin: 0 }}
                            title="Copiar Código de Barras"
                            type={"primary"}
                            icon={"fas fa-barcode"}
                            visible={true}
                            event={() => {
                                window.alert(`Código de Barras: \n${item.codigo_barra}`);
                            }}
                        />
                    ) : null}
                </Td>
                <Td backgroundColor={faturaNaoImportada ? null : backgroundColorTd} alignCenter minWidth={50}>
                    {item.arquivo_pdf && validarDownloadRealizado(item) && (!(item.erros || []).length || item.importacao_validada || props.usuarioLogado.administrador) ? (
                        <ButtonTable
                            style={{
                                margin: 0,
                                backgroundColor: "#28A745",
                                color: "#FFFFFF",
                                border: "1px solid #FFF",
                            }}
                            title='Alterar para "Download Pendente"'
                            icon={"fas fa-check-square"}
                            iconHover={"fas fa-times"}
                            backgroundColorHover="#fc2828"
                            colorHover="white"
                            visible={true}
                            event={() => props.excluirDownloadRealizado(item.id)}
                        />
                    ) : null}
                </Td>
            </NewTr>
        );
    }

    function lista() {
        let statusAtivos = [];
        if (state.statusCorBranca) statusAtivos.push("Não importada");
        if (state.statusCorAzul) statusAtivos.push("Importada e não vencida");
        if (state.statusCorAmarela) statusAtivos.push("Um ou dois dias para o vencimento");
        if (state.statusCorVermelha) statusAtivos.push("Vencendo hoje ou vencida");
        if (state.statusCorVerde) statusAtivos.push("Paga");

        if (state.statusCorBranca && state.statusCorVerde && state.statusCorAzul && state.statusCorAmarela && state.statusCorVermelha) {
            statusAtivos = "Mostrar todas";
        }

        //DADOS PARA IMPRESSÃO DO RELATÓRIO ---------------
        const cabecalho = (
            <NewTr backgroundColorTr={"#FFFFFF"} backgroundColorTd={"#F5F5F5"}>
                <Th sticky style={{ fontSize: "0.7rem" }} alignCenter title="Status da Importação das Faturas de Energia Elétrica">
                    Status Imp. Fatura
                </Th>
                <Th sticky style={{ fontSize: "0.7rem" }} minWidth={75} alignCenter>
                    Competência
                </Th>
                {!usuarioLogadoAcessoCliente && (
                    <Th sticky style={{ fontSize: "0.7rem" }} alignCenter>
                        Cliente
                    </Th>
                )}
                <Th sticky style={{ fontSize: "0.7rem" }} alignCenter>
                    UC
                </Th>
                <Th sticky style={{ fontSize: "0.7rem" }} minWidth={50} alignCenter>
                    Data de Vencimento
                </Th>
                <Th sticky style={{ fontSize: "0.7rem" }} minWidth={50} alignCenter>
                    Data de Pagamento
                </Th>
                <Th sticky style={{ fontSize: "0.7rem" }} minWidth={50} alignCenter>
                    Usuário de Alteração Data de Pagamento
                </Th>
                <Th sticky style={{ fontSize: "0.7rem" }} minWidth={50} alignCenter>
                    Total Fatura
                </Th>
                <Th sticky style={{ fontSize: "0.7rem" }} alignCenter>
                    Faturas
                </Th>
                <Th sticky style={{ fontSize: "0.7rem" }} alignCenter>
                    Cód. Barras
                </Th>
                <Th sticky style={{ fontSize: "0.7rem" }}>
                    Download Realizado
                </Th>
            </NewTr>
        );

        const rodape = (
            <Tr>
                <Td fontWeight="bold">Total</Td>
                <Td colSpan={usuarioLogadoAcessoCliente ? 5 : 6} fontWeight="bold">
                    Qtd. Unidades Ativas Filtradas: {totais.quantidadeUnidadesFiltradas} un.
                </Td>
                <Td alignCenter fontWeight="bold">
                    {"R$ " + adicionarPontosMilhar(totais.totalValorFatura || 0)}
                </Td>
                <Td colSpan={4}></Td>
            </Tr>
        );

        const listaUcsFiltradas = listarUCsFiltradas();

        return (
            <ContentCard>
                <ModalGestorConcessonaria
                    tipo="agua"
                    visible={state.exibirModalGestorConcessionaria && state.itemSelecionado && state.itemSelecionado.gestor_concessionaria_agua}
                    itemSelecionado={state.itemSelecionado}
                    handleClose={() => setState({ ...state, exibirModalGestorConcessionaria: false, itemSelecionado: null })}
                />
                <ContentCardBody>
                    <FiltrosFaturasClienteAgua
                        listaUnidadeConsumidora={listaUcsFiltradas}
                        setState={(novoFiltro) => setState(novoFiltro)}
                        filtroState={{ ...state }}
                        statusAtivos={statusAtivos}
                        quantidadesFiltro={{ ...totais }}
                        usuarioLogadoAcessoCliente={usuarioLogadoAcessoCliente}
                        buttons={[
                            <Button
                                title="Imprime uma lista das faturas filtradas"
                                disabled={props.aguardando}
                                icon="fas fa-print"
                                text="Imprimir Relatório"
                                type={"info"}
                                event={() => {
                                    if (!props.filtro.unidades_consumidoras.length && !props.filtro.id_cliente && faturasFiltradas.length > 100) {
                                        return setError("Selecione um cliente ou alguma unidade consumidora para gerar o relatório");
                                    }
                                    const linhas = montarLinhas(faturasFiltradas);
                                    gerarRelatorio({ statusAtivos, cabecalho, rodape, linhas });
                                }}
                            />,
                            <Button
                                title="Imprime várias faturas combinadas em um único arquivo PDF"
                                disabled={props.aguardando}
                                icon="fas fa-print"
                                text="Imprimir Múltiplas"
                                type={"primary"}
                                event={() => {
                                    //criar função que faz download múltiplo
                                    props.imprimirMultiplasFaturas(faturasFiltradas);
                                }}
                            />,
                            <Button
                                title="Baixa várias faturas ao mesmo tempo, conforme seleção dos filtros da tela"
                                disabled={props.aguardando}
                                text="Baixar Múltiplas"
                                icon="fas fa-file-download"
                                type={"primary"}
                                event={() => {
                                    //criar função que faz download múltiplo
                                   props.baixarMultiplasFaturasPdf(faturasFiltradas);
                                }}
                            />
                        ]}
                    />
                    <Table responsive>
                        <THead>
                            <NewTr backgroundColorTr={"#FFFFFF"} backgroundColorTd={"#F5F5F5"}>
                                <Th sticky style={{ fontSize: "0.7rem" }} alignCenter title="Status da Importação das Faturas de Energia Elétrica">
                                    Status Imp. Fatura
                                </Th>
                                <Th sticky style={{ fontSize: "0.7rem" }} minWidth={75} alignCenter>
                                    Competência
                                </Th>
                                {!usuarioLogadoAcessoCliente && (
                                    <Th sticky style={{ fontSize: "0.7rem" }} alignCenter>
                                        Cliente
                                    </Th>
                                )}
                                <Th sticky style={{ fontSize: "0.7rem" }} alignCenter>
                                    UC
                                </Th>
                                <Th sticky style={{ fontSize: "0.7rem" }} minWidth={75} alignCenter>
                                    Data de Vencimento
                                </Th>
                                <Th sticky style={{ fontSize: "0.7rem" }} minWidth={75} alignCenter>
                                    Data de Pagamento
                                </Th>
                                <Th sticky style={{ fontSize: "0.7rem" }} minWidth={120} alignCenter>
                                    <p style={{ marginBottom: 0 }}>Usuário de Alteração</p>
                                    <p style={{ marginBottom: 0 }}>Data de Pagamento</p>
                                </Th>

                                <Th sticky style={{ fontSize: "0.7rem" }} minWidth={120} alignCenter>
                                    Total Fatura
                                </Th>
                                <Th sticky style={{ fontSize: "0.7rem" }} alignCenter>
                                    Faturas
                                </Th>
                                <Th sticky style={{ fontSize: "0.7rem" }} alignCenter>
                                    Cód. Barras
                                </Th>
                                <Th sticky style={{ fontSize: "0.7rem" }} maxWidth={75} alignCenter>
                                    Download Realizado
                                </Th>
                            </NewTr>
                        </THead>
                        {props.aguardando ? null : (
                            <TBody>
                                {faturasFiltradas.map((item) => buildRow(item))}
                                {rodape}
                            </TBody>
                        )}
                    </Table>
                </ContentCardBody>
            </ContentCard>
        );
    }

    function montarLinhas(faturas) {
        const linhas = [];

        for (const item of faturas) {
            const { nome_unidade_consumidora, nome_concessionaria, nome_cliente } = item;

            const componente = buildRow(item);
            const totalCelulas = componente.props.children.length;
            let linhaModificada = Array.from(componente.props.children)
                .filter((child) => !!child)
                .splice(0, totalCelulas - 3);
            linhaModificada = React.Children.map(linhaModificada, (child, index) => {
                // Extrai propriedades personalizadas da linha original
                const backgroundColorTd = componente.props.backgroundColorTd || "";
                const backgroundColorTr = componente.props.backgroundColorTr || "";

                // 2 = cliente
                if (!usuarioLogadoAcessoCliente && index == 2) {
                    return React.cloneElement(child, {
                        backgroundColor: index % 2 === 0 ? backgroundColorTd : backgroundColorTr,
                        children: (
                            <div
                                style={{
                                    width: 340,
                                    fontSize: "0.75rem",
                                    textAlign: "center",
                                }}
                            >
                                {nome_cliente.length > 40 ? nome_cliente.substring(0, 40) + "..." : nome_cliente}
                            </div>
                        ),
                    });
                }
                // 3 = UC
                if (usuarioLogadoAcessoCliente ? index == 3 : index == 3) {
                    return React.cloneElement(child, {
                        backgroundColor: index % 2 === 0 ? backgroundColorTd : backgroundColorTr,
                        children: (
                            <div
                                style={{
                                    width: usuarioLogadoAcessoCliente ? 1000 : 700,
                                    fontSize: "0.75rem",
                                    textAlign: "center",
                                }}
                            >
                                {nome_unidade_consumidora.length > 45
                                    ? `${nome_unidade_consumidora.substring(0, 45)}... (${nome_concessionaria})`
                                    : `${nome_unidade_consumidora} (${nome_concessionaria})`}
                            </div>
                        ),
                    });
                }
                // Retorna o elemento sem alterações, mas aplica os estilos personalizados
                return React.cloneElement(child, {
                    backgroundColor: index % 2 === 0 ? backgroundColorTd : backgroundColorTr,
                    children: <div style={{ fontSize: "0.75rem" }}>{child.props.children}</div>,
                });
            });
            const linhaSemColunaBotoes = React.cloneElement(componente, {
                children: linhaModificada,
                botoes: [],
            });

            linhas.push(linhaSemColunaBotoes);
        }
        return linhas;
    }

    function gerarRelatorio({ statusAtivos, cabecalho, rodape, linhas }) {
        // props.setAguardando(true);
        const ucsSelecionadas = props.listaUnidadeConsumidora.filter((item) => props.filtro.unidades_consumidoras.find((uc) => uc.value == item.id));
        const nomesUcsSelecionadas = String(ucsSelecionadas.map((item) => item.valor));
        const totalCelulas = cabecalho.props.children.length;
        const linhaModificada = Array.from(cabecalho.props.children)
            .filter((child) => !!child)
            .splice(0, totalCelulas - 3);

        const cabecalhoSemColunasBotoes = (
            <NewTr>
                {linhaModificada.map((el, i) => {
                    const copia = React.cloneElement(
                        el,
                        {
                            key: i,
                            sticky: false,
                            style: { fontSize: "0.75rem", paddingTop: 30 },
                        },
                        [...el.props.children]
                    );
                    return copia;
                })}
            </NewTr>
        );
        const filtro = (
            <b style={{ fontSize: "0.75rem" }}>
                Cliente:
                {` ${(props.listaCliente.find((cliente) => cliente.id == props.filtro.id_cliente) || {}).valor || "Todos"} - `}
                UCs:
                {` ${nomesUcsSelecionadas.length ? nomesUcsSelecionadas : "Todas"} - `}
                Ano:{" " + (props.filtro.ano || "") + " - "}
                Mês:
                {` ${(props.listaMeses.find((mes) => mes.id == props.filtro.mes) || {}).valor || "Todos"} - `}
                Filtro por Status: {String(statusAtivos).replace(/\,/g, ", ")}
            </b>
        );
        const html = ReactDOMServer.renderToString(
            <TabelaFaturaClientePDF
                faturaAgua={true}
                dadosImpressao={{
                    rodape,
                    linhas,
                    filtro,
                    cabecalhoSemColunasBotoes,
                }}
            />
        );
        props.gerarRelatorio({ html, landscape: true, scale: 0.7 });
        // props.setArquivoPDF(pdfBase64, "Relatório faturas.pdf", "landscape");
    }
}

const mapStateToProps = (state) => {
    return {
        sessao: state.auth.usuario,
        usuarioLogado: state.auth.usuarioLogado,
        modoTela: state.fatura.modoTela,
        aguardando: state.fatura.aguardando,
        filtro: state.fatura.filtro,
        lista: state.fatura.listaAgua,
        listaCliente: state.fatura.listaClienteAgua,
        listaConcessionaria: state.fatura.listaConcessionariaAgua,
        listaUnidadeConsumidora: state.fatura.listaUnidadeConsumidoraAgua,
        listaMeses: state.fatura.listaMeses,
        pdf: state.displayPDF.pdf,
        id_pdf: state.displayPDF.id_pdf,
        nomePdf: state.displayPDF.nomePdf,
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setModoTela,
            initForm,
            setFiltro,
            getListaFaturasCliente,
            buscarPdf,
            setArquivoPDF,
            incluirDownloadRealizado,
            excluirDownloadRealizado,
            setAguardando,
            setDataPagamento,
            baixarMultiplasFaturasPdf,
            imprimirMultiplasFaturas,
            gerarRelatorio,
        },
        dispatch
    );
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FaturaAguaCliente));
